module.exports = __webpack_public_path__ + "img/gd.5309163c.webp";